﻿export const CBLB = {
    init: () => {
        const responsiveSizes = [
            { size: 0, label: 'xs' },
            { size: 480, label: 's' },
            { size: 768, label: 'm' },
            { size: 991, label: 'hd' },
            { size: 1280, label: 'uhd' },
            { size: 1601, label: 'xhd' },
            { size: 9000, label: 'xhd' },
        ];

        let currentSizeLabel = '';

        const qsa = () => document.querySelectorAll('.column-wrapper-image');

        const getLabelForWidth = () => {
            for (let i = 0; i < responsiveSizes.length; i++) {
                const s = responsiveSizes[i];
                if (window.matchMedia(`(max-width: ${s.size}px)`).matches) {
                    const prev = i === 0 ? 0 : i - 1;
                    return responsiveSizes[prev].label;
                }
            }
            return responsiveSizes[responsiveSizes.length - 1].label;
        };

        const applyBackgrounds = (label) => {
            qsa().forEach(el => {
                let url = el.getAttribute(`data-bg-${label}`);
                if (!url) {
                    url = el.getAttribute('data-bg-s') || el.getAttribute('data-bg-xs');
                }
                if (url) el.style.backgroundImage = `url("${url}")`;
            });
        };

        const updateBackgrounds = (force = false) => {
            const label = getLabelForWidth();
            if (!force && label === currentSizeLabel) return;
            currentSizeLabel = label;
            applyBackgrounds(label);
            // console.log(`[CBLB] ${window.innerWidth}px → ${label}`);
        };

        const boot = () => {
            updateBackgrounds(true);

            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => updateBackgrounds(false), 150);
            });

            const mo = new MutationObserver(() => updateBackgrounds(true));
            mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
            window.addEventListener('load', () => updateBackgrounds(true));
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', boot, { once: true });
        } else {
            boot();
        }
    }
};
